import { createRoute, lazyRouteComponent } from '@tanstack/react-router'
import { rootRoute } from './root'
import { RouteError } from '@lunary/ui-web/screen-state'

export const authCallbackRoute = createRoute({
  path: 'auth/callback',
  getParentRoute: () => rootRoute,
  component: lazyRouteComponent(() => import('../features/auth/oauth-callback-page'), 'OAuthCallbackPage'),
  errorComponent: RouteError,
})
